module.exports = __webpack_public_path__ + "img/bike-ride-1-min.9820e2c0.png";